module.exports = __webpack_public_path__ + "static/WEDDING E&M-13-4e6a014e9b7b4ca2905ab306781bc3f3.jpg";